var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"periods"},[_c('filter-component',{attrs:{"name":_vm.$t('fields.showDataBy'),"value":_vm.period,"items":_vm.$t('statistics.periodsMember'),"callbackFunction":_vm.filterCallback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }